import './../styles/calculations.scss';

class CalculationsController {

    constructor($scope, calculations, $log) {
        this.$scope = $scope;
        $scope.calculations = calculations.sort((c1, c2) => c1.id - c2.id);
        $log.debug('calculations controller mounting');
    }

}

export const CALCULATIONS_CONTROLLER = ['$scope', 'calculations', '$log', CalculationsController];